import { useEffect } from 'react';
import { SKIPSCREEN_CALENDAR_REFRESH_EVENT } from '../utils/realtimeEvents';

/** Refetch calendar data when meeting requests change over the notifications socket. */
export function useCalendarRealtimeRefresh(refresh: () => void) {
  useEffect(() => {
    const onRefresh = () => refresh();
    window.addEventListener(SKIPSCREEN_CALENDAR_REFRESH_EVENT, onRefresh);
    return () => window.removeEventListener(SKIPSCREEN_CALENDAR_REFRESH_EVENT, onRefresh);
  }, [refresh]);
}
